import { DECISION_NODE_PROCESSING_ACTIONS } from 'constants/decisionTree';
import {
  processRemotelyForCancellationAndRefund,
  processRemotelyForCancellation,
  processRemotelyForRefund,
  processRemotelyForCancellationAndRefundOrDiscount,
  processRemotelyForDiscount,
  processRemotelyForCancellationOrDiscount,
} from './CancellationActions';
import { checkRbiRemediations } from './RBIActions';

export const DECISION_NODE_PROCESSING_FUNCTIONS = {
  [DECISION_NODE_PROCESSING_ACTIONS.CANCEL_AND_REFUND_PROCESSING]: processRemotelyForCancellationAndRefund,
  [DECISION_NODE_PROCESSING_ACTIONS.CANCELLATION_PROCESSING]: processRemotelyForCancellation,
  [DECISION_NODE_PROCESSING_ACTIONS.REFUND_PROCESSING]: processRemotelyForRefund,
  [DECISION_NODE_PROCESSING_ACTIONS.CANCEL_AND_REFUND_OR_DISCOUNT_PROCESSING]:
    processRemotelyForCancellationAndRefundOrDiscount,
  [DECISION_NODE_PROCESSING_ACTIONS.DISCOUNT_PROCESSING]: processRemotelyForDiscount,
  [DECISION_NODE_PROCESSING_ACTIONS.CANCELLATION_OR_DISCOUNT_PROCESSING]: processRemotelyForCancellationOrDiscount,
  [DECISION_NODE_PROCESSING_ACTIONS.CHECK_RBI_REMEDIATIONS]: checkRbiRemediations,
};
